/**
 * useToast Hook
 * Provides toast notifications
 */

import { useState, useCallback } from 'react'

export function useToast() {
  const [toastState, setToastState] = useState({
    isOpen: false,
    message: '',
    type: 'success',
    duration: 5000
  })

  const showToast = useCallback((message, type = 'success', duration = 5000) => {
    setToastState({
      isOpen: true,
      message,
      type,
      duration
    })
  }, [])

  const success = useCallback((message, duration) => {
    showToast(message, 'success', duration)
  }, [showToast])

  const error = useCallback((message, duration) => {
    showToast(message, 'error', duration)
  }, [showToast])

  const warning = useCallback((message, duration) => {
    showToast(message, 'warning', duration)
  }, [showToast])

  const info = useCallback((message, duration) => {
    showToast(message, 'info', duration)
  }, [showToast])

  const closeToast = useCallback(() => {
    setToastState(prev => ({ ...prev, isOpen: false }))
  }, [])

  return {
    toastState,
    showToast,
    success,
    error,
    warning,
    info,
    closeToast
  }
}
